module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('v-card', {
    staticClass: "long-text grey--text text--darken-2"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('img', {
    staticClass: "center-img auto-downscale",
    attrs: {
      "src": require("../assets/404.png")
    }
  }), _c('br'), _vm._v(" "), (this.language === 'de') ? _c('div', [_c('span', {
    staticStyle: {
      "padding-right": "8px"
    }
  }, [_vm._v("Die Seite unter")]), _vm._v(" "), _c('span', {
    staticClass: "orange lighten-3 elevation-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.$route.path) + "\n                        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_vm._v("wurde nicht gefunden.")]), _vm._v(" "), _c('div', [_vm._v("\n                            Sie werden "), (_vm.redir > 0) ? _c('span', [_vm._v("in " + _vm._s(_vm.redir) + " Sekunde"), (_vm.redir > 1) ? _c('span', [_vm._v("n")]) : _vm._e()]) : _c('span', [_vm._v("jetzt")]), _vm._v(" auf die Homepage weitergeleitet.\n                        ")])]) : _vm._e()])]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "warning": ""
    },
    model: {
      value: (_vm.prog),
      callback: function($$v) {
        _vm.prog = $$v
      },
      expression: "prog"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8a4e726"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 163
// module chunks = 1 2